import React, { useState } from 'react';
import CollapsibleCard from '../common/CollapsibleCard'
import Collapse from 'react-bootstrap/Collapse';
import KeyValue from '../common/KeyValue'
import { Link } from "../../../helpers/link";

export default function UrlScanCompleteListItem(props) {
    const { link, completedScan } = props;
    const [open, setOpen] = useState(false);
    const [destinationLinkToggle, setDestinationLinkToggle] = useState(false);
    const collapseIcon = <i className="fas fa-chevron-up"></i>;
    const expandIcon = <i className="fas fa-chevron-down"></i>;
    const screenshotUrl = completedScan["task"]["screenshotURL"];
    const destinationLink = new Link(completedScan["page"]["url"], link.text);
    const urlDomain = completedScan["page"]["domain"];
    const ipAddress = completedScan["page"]["ip"];
    const country = completedScan["countryName"] || completedScan["page"]["country"];
    const isMalicious = completedScan["verdicts"]["overall"]["malicious"];
    const hasVerdicts = completedScan["verdicts"]["overall"]["hasVerdicts"];
    const whoIsLink = <a href={`https://www.whois.com/whois/${urlDomain}`} target="_blank" rel="noreferrer">{"VIEW WHOIS"}</a>;
   
    let isMaliciousDescr = "(Unknown)";
    let verdictCssClass = ""
    if(hasVerdicts === 0){
        isMaliciousDescr = "(No verdict)";
        verdictCssClass = "no_verdict";
    }
    else if(isMalicious === true){
        isMaliciousDescr = "Yes";
        verdictCssClass = "is_malicious";
    }
    else if(isMalicious === false){
        isMaliciousDescr = "No";
        verdictCssClass = "is_safe";
    }
    return (
        <li className="list-group-item text-break">
            {/* <CollapsibleCard header={link.shortText} ctrlName={`completedUrlScan_${props.idx}`}>
                <KeyValue label="Is Malicious?:" value={isMaliciousDescr}/>
                <KeyValue label="IP Address:" value={ipAddress || "(Not Found)"}/>
                <KeyValue label="Country:" value={country || "(Not Found)"}/>
                <KeyValue label="Domain:" value={urlDomain || "(Not Found)"} link_btn={whoIsLink}/>
                
                <a className="text-decoration-none" href={screenshotUrl} target="_blank" rel="noreferrer">
                    <figure className="mt-2">
                        <figcaption className="figure-caption font-weight-bold mb-1">Click image to view full screen:</figcaption>
                        <img src={screenshotUrl} className="figure-img img-fluid rounded" alt={"Screenshot of web page: " + link.href}/>
                    </figure>
                </a>
            </CollapsibleCard> */}
                <div className={"collapse_target " + verdictCssClass}
                        onClick={() => setOpen(!open)}
                        aria-controls={`completedUrlScan_${props.idx}_Body`}
                        aria-expanded={open}
                >
                    <h5 title={destinationLink.text}>
                        <small className="font-weight-bold">{destinationLink.shortText}</small>
                    </h5>
                </div>
                <div>
                    <Collapse in={open}>
                        <div id={`completedUrlScan_${props.idx}_Body`} title={destinationLink.href}>
                            <KeyValue 
                                label={
                                    <span style={{cursor: "pointer"}} onClick={() => setDestinationLinkToggle(!destinationLinkToggle)}>
                                        Destination URL: <br/> (click to toggle full url)
                                    </span>
                                }
                                value={
                                    destinationLinkToggle ? 
                                    destinationLink.href : 
                                    destinationLink.shortHref
                                }
                            />
                            <KeyValue label="Is Malicious?:" value={isMaliciousDescr}/>
                            <KeyValue label="IP Address:" value={ipAddress || "(Not Found)"}/>
                            <KeyValue label="Country:" value={country || "(Not Found)"}/>
                            <KeyValue label="Domain:" value={urlDomain || "(Not Found)"} link_btn={whoIsLink}/>
                            
                            <a className="text-decoration-none" href={screenshotUrl} target="_blank" rel="noreferrer">
                                <figure className="mt-2">
                                    <figcaption className="figure-caption font-weight-bold mb-1">Click image to view full screen:</figcaption>
                                    <img src={screenshotUrl} className="figure-img img-fluid rounded" alt={"Screenshot of web page: " + link.href}/>
                                </figure>
                            </a>
                        </div>
                    </Collapse>
                </div>
                <div className="text-center collapse_target" 
                    onClick={() => setOpen(!open)}
                    aria-controls={`completedUrlScan_${props.idx}_Body`}
                    aria-expanded={open}
                >
                    {open ? collapseIcon : expandIcon}
                </div>
        </li>
    );
}